import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Toggle, SelectButton, InfoPanel } from '@checkmarx/cx-ui';
import HelpTooltip from '../../portal/controls/helpTooltip';
import RolesDropdownContainer from '../../portal/rolesDropdownContainer';
import PortalCheckBox from '../../portal/controls/checkbox';
import SelectTeamDialog from '../../portal/controls/selectTeamDialog';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';

@inject('translationsStore', 'teamsStore') @observer
export default class RoleMappingSection extends Component {
  
    currentLdapStore = this.props.currentLdapStore;
    ldapValidator = this.props.ldapValidator;
    translations = this.props.translationsStore;
    t = this.translations.translate;

    state = {
        showTeamDialog: false,
        teamFullName: '',
        currentlySelectedTeamId: this.props.currentLdapStore.defaultTeamId ? this.props.currentLdapStore.defaultTeamId : -1
    };

    openTeamsDialog = () => {

        if(this.isDefaultTeamDisabled())
            return null;

        this.props.teamsStore.getAllTeams()
            .then(() => {

                this.setState({
                    showTeamDialog: true
                });

            })
            .catch((err) => {
            });
    }

    closeTeamsDialog = () => {

        this.setState({
            showTeamDialog: false
        });
    }

    onTeamSelect = (selectedKeys) => {

        this.setState({
            currentlySelectedTeamId: parseInt(selectedKeys[0])
        });
    }

    teamSelected = () => {

        this.currentLdapStore.setDefaultTeamId(this.state.currentlySelectedTeamId);
        this.ldapValidator.validateDefaultTeamId(this.state.currentlySelectedTeamId);

        this.closeTeamsDialog();
    }

    onChangeDefaultRoleId =(e, index, value) => { 
        
        this.currentLdapStore.setDefaultRoleId(value);
        this.ldapValidator.validateDefaultRoleId(value)
    }

    onChangeUpdateTeamAndRoleUponLoginEnabled = () => 
        this.currentLdapStore.setUpdateTeamAndRoleUponLoginEnabled(!this.currentLdapStore.updateTeamAndRoleUponLoginEnabled);

    onChangePeriodicalSynchronizationEnabled = () => 
        this.currentLdapStore.setPeriodicalSynchronizationEnabled(!this.currentLdapStore.periodicalSynchronizationEnabled);
        
    handleChangeAdvancedTeamAndRoleMapping = (e) => {

        this.currentLdapStore.setAdvancedTeamAndRoleMappingEnabled(e.target.checked);
        this.ldapValidator.setAdvancedTeamAndRoleMappingEnabled(e.target.checked);
    };

    handleChangeEnableDefaultTeam = (e) => {
        this.currentLdapStore.setDefaultTeamEnabled(e.target.checked);    
        this.ldapValidator.setDefaultTeamEnabled(e.target.checked);
    };

    handleChangeEnableDefaultRole = (e) => {
        this.currentLdapStore.setDefaultRoleEnabled(e.target.checked);    
    };

    parseTeamName = (fullPathName) => {

        if(fullPathName === undefined
            || fullPathName === '') {

            return '';
        }

        return fullPathName.substr(1).slice(0);
    }

    isDefaultTeamDisabled = () => this.currentLdapStore.advancedTeamAndRoleMappingEnabled && !this.currentLdapStore.defaultTeamEnabled 
    
    isDefaultRoleDisabled = () => this.currentLdapStore.advancedTeamAndRoleMappingEnabled && !this.currentLdapStore.defaultRoleEnabled 



    render() {

        const selectedKeys = this.state.currentlySelectedTeamId ? [`${this.state.currentlySelectedTeamId}`] : [];
        const fullPathName = this.props.teamsStore.getTeamFullName(this.currentLdapStore.defaultTeamId);

        const roleMapping = this.currentLdapStore.synchronizationEnabled == true ? <div>
            <div className='sub-title'>
                {this.t('ROLE_AND_TEAM_MAPPING')} <HelpTooltip text={this.t('ROLE_MAPPING_HELP_TOOLTIP')} />
            </div>
                <div className='form-row start'>
                    <RolesDropdownContainer
                        dataCy='ddl-default-role'
                        hintText={this.t('DEFAULT_ROLE')}
                        floatingLabelText={this.t('DEFAULT_ROLE')}
                        width='47%'
                        disabled={this.isDefaultRoleDisabled() || this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeDefaultRoleId}
                        errorText={this.ldapValidator.defaultRoleIdValidationMessage}
                        value={this.isDefaultRoleDisabled() ? '' : this.currentLdapStore.defaultRoleId}
                        helpTooltipText={this.t('DEFAULT_ROLE_HELP_TOOLTIP')}
                        insertDefaultValue
                    />
                    <SelectButton
                        dataCy='select-default-team'
                        style={{marginTop: '18px'}}
                        placeHolderText={<TextfieldFloatingText title={ this.t('DEFAULT_TEAM') } required={this.isDefaultTeamDisabled() ? false : true}/>}
                        disabled={this.isDefaultTeamDisabled() || this.currentLdapStore.createUpdateLDAPServersProgress}
                        width='47%'
                        style={{top: '12px'}}
                        buttonText={this.t('SELECT')}
                        onClick={this.openTeamsDialog}
                        title={fullPathName}
                        value={this.isDefaultTeamDisabled() ? '' : this.parseTeamName(fullPathName)}
                        errorText={this.ldapValidator.defaultTeamIdValidationMessage}
                    />
                </div>
                <div className='form-row use-ssl'>
                    <PortalCheckBox
                        dataCy='cbx-update-role-and-team-upon-login'
                        checked={this.currentLdapStore.updateTeamAndRoleUponLoginEnabled}
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        label={this.t('AUTOMATICALLY_UPDATE_ROLE_AND_TEAM_UPON_LOGIN')}
                        onCheck={this.onChangeUpdateTeamAndRoleUponLoginEnabled}
                        helpTooltipText={this.t('AUTOMATICALLY_UPDATE_ROLE_AND_TEAM_UPON_LOGIN_HELP_TOOLTIP')}
                    />
                </div>
                <div className='form-row verify-ssl'>
                    <PortalCheckBox
                        dataCy='cbx-periodical-sync'
                        checked={this.currentLdapStore.periodicalSynchronizationEnabled}
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        label={this.t('PERIODICALLY_SYNC_USER_AVAILABILITY')}
                        onCheck={this.onChangePeriodicalSynchronizationEnabled}
                        helpTooltipText={this.t('PERIODICALLY_SYNC_USER_AVAILABILITY_HELP_TOOLTIP')}
                    />
                </div>
                <div className='form-row enable-server' style={{paddingTop:  '25px'}}>
                    <Toggle
                        dataCy='tgl-enable-advanced-mapping'
                        onChange={this.handleChangeAdvancedTeamAndRoleMapping}
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        checked={this.currentLdapStore.advancedTeamAndRoleMappingEnabled}
                        text={this.t('ADVANCED_TEAM_AND_ROLE_MAPPING')}
                        helpTooltipText={<div style={{width: '300px'}}>{this.t('ADVANCED_TEAM_AND_ROLE_MAPPING_HELP_TOOLTIP')}</div>}
                    /> 
                </div>

                {this.currentLdapStore.advancedTeamAndRoleMappingEnabled ?
                    <div className='form-row enable-server'>
                        <Toggle
                            dataCy='tgl-enable-default-team'
                            onChange={this.handleChangeEnableDefaultTeam}
                            disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                            checked={this.currentLdapStore.defaultTeamEnabled}
                            text={this.t('ENABLE_DEFAULT_TEAM')}
                            helpTooltipText={<div style={{width: '300px'}}>{this.t('ENABLE_DEFAULT_TEAM_HELP_TOOLTIP')}</div>}
                        /> 
                          <Toggle
                            dataCy='tgl-enable-default-role'
                            onChange={this.handleChangeEnableDefaultRole}
                            disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                            checked={this.currentLdapStore.defaultRoleEnabled}
                            text={this.t('ENABLE_DEFAULT_ROLE')}
                            helpTooltipText={<div style={{width: '300px'}}>{this.t('ENABLE_DEFAULT_ROLE_HELP_TOOLTIP')}</div>}
                        /> 
                    </div> : null
                }

                <SelectTeamDialog
                    openDialog={this.state.showTeamDialog}
                    closeDialog={this.closeTeamsDialog}
                    onTeamSelect={this.onTeamSelect}
                    selectedKeys={selectedKeys}
                    onSave={this.teamSelected}
                    translations={{
                        cancelButton: this.t('CANCEL'),
                        headerTitle: this.t('SELECT_TEAM'),
                        selectTeamButton: this.t('SELECT_TEAM')
                    }}
                />
            </div> 
                :   <InfoPanel
                        style={{marginTop: '15px', maxWidth: '1301px'}}
                    >
                        {this.t('ENABLE_SYNCHRONIZATION_SECTION_DESCRIPTION')}
                    </InfoPanel>
        
        return (
            <div>
                {roleMapping}
            </div>
        );
  }
}
